import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AWS from "../../../assets/images/aws.svg";
import Azure from "../../../assets/images/azure.svg";
import GCP from "../../../assets/images/gcp.svg";
import GetStarted from "./GetStarted";
import Configure from "./Configure";
import Review from "./Review";
import {
  Card,
  CardFooter,
  CardHeader,
  Typography,
  Button,
  CardBody,
} from "@material-tailwind/react";

export default function CreateNewIntegration() {
  const [selectedProvider, setSelectedProvider] = useState("");
  const [step, setStep] = useState("");
  const [scope, setScope] = useState("");
  const [uploadedJson, setUploadedJson] = useState(null);

  const [formDataAWS, setFormDataAWS] = useState({
    accname: "",
    accID: "",
    role: "",
  });
  const [formDataAzure, setFormDataAzure] = useState({
    tenantID: "",
    accname: "",
    subID: "",
    appID: "",
    appClientSecret: "",
  });
  const [formDataGCP, setFormDataGCP] = useState({
    accname: "",
    prjID: "",
  });
  const navigate = useNavigate();

  const gridItem = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    border: "1px solid #ccc",
    backgroundColor: "#f4f4f4",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "transform 0.2s",
  };

  const handleIntegrationSelect = (integrationName) => {
    setSelectedProvider(integrationName);
    navigate("/newIntegration");
  };

  return (
    <div className="app-main__inner !pl-20">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        {step === "Get Started" ? (
          <GetStarted
            selectedProvider={selectedProvider}
            setStep={setStep}
            setScope={setScope}
            scope={scope}
          />
        ) : step === "Configure" ? (
          <Configure
            selectedProvider={selectedProvider}
            setStep={setStep}
            setFormDataAWS={setFormDataAWS}
            formDataAWS={formDataAWS}
            scope={scope}
            formDataAzure={formDataAzure}
            setFormDataAzure={setFormDataAzure}
            formDataGCP={formDataGCP}
            setFormDataGCP={setFormDataGCP}
            uploadedJson={uploadedJson}
            setUploadedJson={setUploadedJson}
          />
        ) : step === "Review" ? (
          <Review
            selectedProvider={selectedProvider}
            setStep={setStep}
            scope={scope}
            formDataAWS={formDataAWS}
            formDataAzure={formDataAzure}
            formDataGCP={formDataGCP}
            uploadedJson={uploadedJson}
          />
        ) : (
          <>
            <CardHeader
              floated={false}
              shadow={false}
              className=" bg-transparent rounded-none"
            >
              <Typography
                variant="h4"
                color="blue-gray"
                className="mb-2 text-blue-gray-800"
              >
                Add New | Cloud Account
              </Typography>
              <Typography
                variant="h6"
                color="blue-gray"
                className="mb-4 !text-blue-gray-700 !font-normal"
              >
                Onboard your cloud accounts and detect security
                misconfigurations
              </Typography>
            </CardHeader>
            <CardBody>
              <div className="grid grid-cols-3 gap-5">
                <div
                  style={{
                    ...gridItem,
                    border:
                      selectedProvider === "AWS"
                        ? "2px solid 	#1E90FF"
                        : "1px solid #ccc",
                    backgroundColor:
                      selectedProvider === "AWS" ? "lightblue" : "",
                  }}
                  onClick={() => handleIntegrationSelect("AWS")}
                >
                  <img src={AWS} alt="AWS" className="rounded-lg w-20 h-auto" />
                  <Typography
                    variant="p"
                    color="blue-gray"
                    className="mt-2 font-semibold"
                  >
                    Amazon Web Services
                  </Typography>
                </div>
                <div
                  style={{
                    ...gridItem,
                    border:
                      selectedProvider === "Azure"
                        ? "2px solid 	#1E90FF"
                        : "1px solid #ccc",
                    backgroundColor:
                      selectedProvider === "Azure" ? "lightblue" : "",
                  }}
                  onClick={() => handleIntegrationSelect("Azure")}
                >
                  <img
                    src={Azure}
                    alt="Azure"
                    className="rounded-lg w-20 h-auto"
                  />
                  <Typography
                    variant="p"
                    color="blue-gray"
                    className="mt-2 font-semibold"
                  >
                    Azure Cloud
                  </Typography>
                </div>
                <div
                  style={{
                    ...gridItem,
                    border:
                      selectedProvider === "GCP"
                        ? "2px solid 	#1E90FF"
                        : "1px solid #ccc",
                    backgroundColor:
                      selectedProvider === "GCP" ? "lightblue" : "",
                  }}
                  onClick={() => handleIntegrationSelect("GCP")}
                >
                  <img src={GCP} alt="GCP" className="rounded-lg w-20 h-auto" />
                  <Typography
                    variant="p"
                    color="blue-gray"
                    className="mt-2 font-semibold"
                  >
                    Google Cloud Platform
                  </Typography>
                </div>
              </div>
            </CardBody>
            <CardFooter>
              <div className="flex flex-row gap-5 justify-end">
                <Button
                  variant="gradient"
                  color="light-blue"
                  // className="mr-4"
                  disabled={!selectedProvider}
                  onClick={() => {
                    setStep("Get Started");
                  }}
                >
                  Next
                </Button>

                <Button
                  variant="text"
                  color="red"
                  onClick={() => {
                    navigate("/inventory/assets");
                  }}
                >
                  Cancel
                </Button>
              </div>
            </CardFooter>
          </>
        )}
      </Card>
    </div>
  );
}
